import { addDimensions } from '@eventbrite/site-analytics';
import {
    getSplitNames,
    getTreatments,
    initSplitSdk,
} from '@splitsoftware/splitio-redux';
import { Dispatch } from 'redux';
import { isSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import { WithAppNamespace } from '../state/app';
import { WithSplitioNamespace } from '../state/splitio';
import { WithUserNamespace } from '../state/user';
import { getSplitioClient } from '../utils/splitio';

export const initializeSplitioSdk = () => async (
    dispatch: Dispatch<CheckoutState>,
    getState: () => WithAppNamespace & WithUserNamespace & WithSplitioNamespace,
) => {
    const {
        app: {
            isProd,
            splitIOProdKey,
            event: { id: eventId },
        },
    } = getState();

    // Don't initialize SDK if there is no prod key (eg. unit tests)
    if (!splitIOProdKey) return;

    await dispatch(
        initSplitSdk({
            config: getSplitioClient(eventId, isProd ? splitIOProdKey : null),
        }),
    );

    const splitNames = getSplitNames();

    // Apply attributes to evaluate splits
    dispatch(
        getTreatments({
            splitNames: splitNames,
            attributes: { eventId },
        }) as any,
    );

    // Send split values to analytics
    const state = getState();
    const activeSplits = splitNames.flatMap((name) => {
        const value = isSplitTreatmentEnabled(state, name);
        return value ? [name] : [];
    });
    addDimensions({ experimentId: activeSplits.join(',') });

    return Promise.resolve();
};
